import { ReportSectionRetryRequest } from '@digital-twins/shared-types/reporting'

import { deckApi, experimentsApi } from '@/lib/api'

export const studyReportClient = {
  getFull: (studyId: string) => experimentsApi.getFull(studyId),
  getStudy: (studyId: string) => experimentsApi.get(studyId),
  getSurveyJson: (studyId: string) => experimentsApi.getSurveyJson(studyId),
  regenerateReport: (
    studyId: string,
    sectionRetry?: ReportSectionRetryRequest,
  ) => experimentsApi.regenerateReport(studyId, sectionRetry),
  rerun: (studyId: string) => experimentsApi.rerun(studyId),
  getDeck: (studyId: string) => deckApi.getDeck(studyId),
  getAudienceProfiles: (studyId: string) =>
    experimentsApi.getAudienceProfiles(studyId),
  saveAudienceProfiles: (
    studyId: string,
    profiles: Parameters<typeof experimentsApi.saveAudienceProfiles>[1],
  ) => experimentsApi.saveAudienceProfiles(studyId, profiles),
}
